import { Report } from "@/@types/reports/calls";
import { ReportTypes } from "@/app/reports/utils/enums";
import { TABLE_PAGE_SIZE } from "@/app/shared/utils/constants";
import httpManager from "@/app/shared/utils/httpManager";

class CallsReportService {
  private baseUrl = `/reports/${ReportTypes.Calls}`;

  private getDatesParam(dates: string[]) {
    const startDate = `${dates.at(0)} 00:00:00`;
    const endDate = `${dates.at(1)} 23:59:59`;

    return `start_date=${startDate}&end_date=${endDate}`;
  }

  async getList(dates: string[] | null, page: number): Promise<Report> {
    if (!dates) throw new Error("Invalid date");

    const datesParam = this.getDatesParam(dates);

    const pagination = `limit=${TABLE_PAGE_SIZE}&offset=${(page - 1) * TABLE_PAGE_SIZE}`;

    const url = `${this.baseUrl}/?${datesParam}&${pagination}`;

    const response = await httpManager.get(url);

    return response.data;
  }

  async download(dates: string[] | null) {
    if (!dates) throw new Error("Invalid date");

    const datesParam = this.getDatesParam(dates);

    const url = `${this.baseUrl}/download/?${datesParam}`;

    const response = await httpManager.post(url, {}, { blob: true });

    return response;
  }
}

export const callsReportService = new CallsReportService();
